const ROOT_URL = 'https://realworld-api.herokuapp.com/api';

const User_URL = ROOT_URL + '/user';
const Login_URL = ROOT_URL + '/users/login';
const Register_URL = ROOT_URL + '/users/register';
const Articles_URL = ROOT_URL + '/articles';
const Profiles_URL = ROOT_URL + '/profiles';
const Tags_URL = ROOT_URL + '/tags';

export {
  ROOT_URL,
  User_URL,
  Login_URL,
  Register_URL,
  Articles_URL,
  Profiles_URL,
  Tags_URL,
};
